import { useAuth0 } from '@auth0/auth0-react';
import {useContext, useState} from 'react';
import {Nav, Navbar, Container, NavbarBrand, NavDropdown} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { LoginLogoutComponent } from './LoginLogoutComponent';
import logo from '../img/logo-dinney.png'
import { isMobile } from 'react-device-detect';
import {UserContext} from "../../App";
import {ConfigProvider, Tag} from 'antd';
import {InstallPwa} from "./InstallPwa";

export const DinneyNavbar = () => {

    const {
        isAuthenticated,
        user,
    } = useAuth0();

    const [expanded, setExpanded] = useState(false);
    const {userCompanyName} = useContext(UserContext)
    
      return(
        <Navbar expanded={expanded} expand="lg" sticky="top" data-bs-theme="dark" className="bg-body-tertiary custom-navbar-chip bg-custom-navbar p-3 mb-0">
        <Container fluid>
            <NavbarBrand href="/home">
            <img
              src={logo}
              width="30"
              height="30"
              className="d-inline-block align-middle mx-3"
              alt="Dinney"
            />
            {isMobile ?
            <span>Dinney</span>
            :
              <>
              <span>Dinney | </span>
              {userCompanyName !== undefined && userCompanyName !== '' ?
                  <ConfigProvider
                      theme={{
                          components: {
                              Tag: {
                                  defaultBg: '#ffffff',
                                  defaultColor: '#C5B5F2'
                              },
                          },
                          token: {
                              borderRadius: 18,
                              fontSize: 18
                          },

                      }}
                  >
                      <Tag>{`${userCompanyName}`}</Tag>
                  </ConfigProvider>
              : 
              ``}
              </>
            }
            
            </NavbarBrand>
            <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ms-auto">
                {userCompanyName !== undefined && userCompanyName !== '' && isMobile ?
                    <ConfigProvider
                        theme={{
                            components: {
                                Tag: {
                                    defaultBg: '#ffffff',
                                    defaultColor: '#C5B5F2'
                                },
                            },
                            token: {
                                borderRadius: 18,
                                fontSize: 18
                            },

                        }}
                    >
                        <Tag>{`${userCompanyName}`}</Tag>
                    </ConfigProvider>
                : 
                <></>}
                <Nav.Link as={Link} to='/home' onClick={() => setExpanded(false)}>Home</Nav.Link>
                
                {isAuthenticated && user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE) &&
                <>
                  <NavDropdown title="Rozliczenia" id="calculations" className={`custom-navbar-dropdown${isMobile ? `-mobile` : ``}`}>
                      <NavDropdown.Item className={`${isMobile ? `` : `text-color`}`} as={Link} to='/mealselection' onClick={() => setExpanded(false)}>
                          Posiłki
                      </NavDropdown.Item>
                      <NavDropdown.Item className={`${isMobile ? `` : `text-color`}`} as={Link} to='/mealsdailysummary' onClick={() => setExpanded(false)}>
                          Dzienne ilości
                      </NavDropdown.Item>
                      <NavDropdown.Item className={`${isMobile ? `` : `text-color`}`}  as={Link} to='/customersforpayments' onClick={() => setExpanded(false)}>
                          Płatności
                      </NavDropdown.Item>
                  </NavDropdown>
                </>
                }
                {isAuthenticated && (user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE) || user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT)) &&
                    <Nav.Link as={Link} to='/menuweeks' onClick={() => setExpanded(false)}>Menu</Nav.Link>
                }
                {isAuthenticated && user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE) &&
                  <>
                    <Nav.Link as={Link} to='/meals' onClick={() => setExpanded(false)}>Posiłki</Nav.Link>
                    <Nav.Link as={Link} to='/customers' onClick={() => setExpanded(false)}>Rodzice</Nav.Link>
                  </>
                }
                {isAuthenticated && (user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE)) &&
                  <Nav.Link as={Link} to='/account' onClick={() => setExpanded(false)}>Konto użytkownika</Nav.Link>
                }
                {isAuthenticated && (user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_ADMIN)
                        || user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT)) &&
                    <>
                        <Nav.Link as={Link} to='/mealselection' onClick={() => setExpanded(false)}>Zaznacz posiłki</Nav.Link>
                    </>
                }
                {isAuthenticated && user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_ADMIN) &&
                <>
                  <Nav.Link as={Link} to='/dinneyadmin' onClick={() => setExpanded(false)}>Panel admina</Nav.Link>
                </>
                }
                <InstallPwa setExpanded={setExpanded} />
                <LoginLogoutComponent setExpanded={setExpanded} />
                </Nav>
            </Navbar.Collapse>
        </Container>
      </Navbar>
      )
  }